import { ContributorCategoriesGridView } from '~/components/contributors/categories';
import { PageContainer } from '~/components/page-container';

export function ContributorCategories() {
	return (
		<PageContainer>
			<ContributorCategoriesGridView />
		</PageContainer>
	);
}
